import { TranslationGroup } from './translationGroup';

export enum TranslationMnemonic {
  // Common group
  CommonDetailsLabel = 'commonDetailsLabel',
  CommonShowMoreLabel = 'commonShowMoreLabel',
  CommonClientProfileCitizenship = 'commonClientProfileCitizenship',

  // Catalog group
  CatalogItemOptionExperienceEmpty = 'catalogItemOptionExperienceEmpty',
  CatalogItemViewOnMap = 'catalogItemViewOnMap',
  CatalogItemPriceNotSetLabel = 'catalogItemPriceNotSetLabel',
}

// eslint-disable-next-line prettier/prettier
export type TranslationMnemonicsForGroup<G extends TranslationGroup, M = TranslationMnemonic> = M extends `${G}${string}` ? M : never;

export class TranslationGroupedDictionary {
  [TranslationGroup.Catalog]?: {
    [T in TranslationMnemonicsForGroup<TranslationGroup.Catalog>]?: { [Key in T]: string };
  };
  [TranslationGroup.Common]?: {
    [T in TranslationMnemonicsForGroup<TranslationGroup.Common>]?: { [Key in T]: string };
  };
}

export type TranslationDictionary = {
  [T in TranslationMnemonic]: string;
};
